  document.addEventListener('DOMContentLoaded', function() {
  var splide = new Splide('.splide', {
    direction: 'ttb',
    height: '100vh',
    perPage: 1, 
    perMove: 1, 
    autoplay: false, 
    speed: 1200, 
    pagination: false,
    interval: 4000,
    arrows: false,
  });
  splide.mount();
  var isScrolling = false;
  document.querySelector('.splide').addEventListener('wheel', function(event) {
    if (splide.options.direction === 'ttb') {
      event.preventDefault();
      if (!isScrolling) {
        isScrolling = true;
        setTimeout(function() {
          isScrolling = false;
        }, 1000); 
        if (event.deltaY < 0) {
          splide.go('-1'); 
        } else {
          splide.go('+1');
        }
      }
    }
  });
});



document.addEventListener('DOMContentLoaded', function() {
    var footer = document.getElementById('SiteFooter');
    var footerHtml = footer.innerHTML;

    var container = document.getElementById('your-container-id');
    container.innerHTML += footerHtml;

      // Get all button elements with the specified classes
    var buttons = document.querySelectorAll('.footer-title__button.h5');

    // Add a click event listener to each button
    buttons.forEach(function(button) {
        button.addEventListener('click', function() {
            // Toggle the 'is-expanded' class on the clicked button
            button.classList.toggle('is-expanded');
        });
    });

});



